module.exports = __webpack_public_path__ + "img/2_112.1baf16a9.png";